module.exports = __webpack_public_path__ + "d428e1cce2401299ef6e4df9ba17ee18.png";